import logo from 'assets/header-prevencor-xx.png';
import md5 from 'md5';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import fetchImageBase64 from 'utils/helpers';

// import { analisarHemodinamica, parseTilt } from './helpers';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

/* function sectionTitle(text) {
  return {
    text,
    bold: true,
    decoration: 'underline',
    margin: [0, 8, 0, 3],
  };
} */

/* function buildChartData(tiltText) {
  const parsed = parseTilt(tiltText);
  if (!parsed?.repouso || !parsed?.inclinacao) return [];

  const repouso = parsed.repouso;
  const inclinacao = parsed.inclinacao;

  const valido =
    Number.isFinite(repouso.PAS) &&
    Number.isFinite(repouso.PAD) &&
    Number.isFinite(repouso.FC) &&
    Number.isFinite(inclinacao.PAS) &&
    Number.isFinite(inclinacao.PAD) &&
    Number.isFinite(inclinacao.FC);

  if (!valido) return [];

  return [
    {
      periodo: 'Repouso',
      PAS: repouso.PAS,
      PAD: repouso.PAD,
      FC: repouso.FC,
    },
    {
      periodo: 'Inclinação',
      PAS: inclinacao.PAS,
      PAD: inclinacao.PAD,
      FC: inclinacao.FC,
    },
  ];
}
 */
/* function buildAnaliseLines(chartData) {
  if (!Array.isArray(chartData) || chartData.length === 0) return [];

  const analise = analisarHemodinamica(chartData);
  if (!analise) return [];

  return [
    `- Variação PAS: ${analise.pas.inicio} -> ${analise.pas.fim} mmHg (${analise.pas.variacao} mmHg): ${analise.pas.analise}`,
    `- Variação PAD: ${analise.pad.inicio} -> ${analise.pad.fim} mmHg (${analise.pad.variacao} mmHg): ${analise.pad.analise}`,
    `- Variação FC: ${analise.fc.inicio} -> ${analise.fc.fim} bpm (${analise.fc.variacao} bpm): ${analise.fc.analise}`,
  ];
} */

export async function generatePDFTilt({ tilt }) {
  const safeTilt = tilt || {};
  const textoLaudo = String(safeTilt.TILTTEST ?? '');
  // const chartData = buildChartData(textoLaudo);
  // const analiseLines = buildAnaliseLines(chartData);
  const logoBase64 = await fetchImageBase64(logo);
  const hashAssinatura = safeTilt.HASH || md5(JSON.stringify(safeTilt));

  const content = [
    {
      text: 'Laudo de Tilt Test'.toUpperCase(),
      bold: true,
      decoration: 'underline',
      alignment: 'center',
      margin: [0, 0, 0, 10],
      fontSize: 14,
    },
    {
      text: [
        { text: 'Paciente: ', bold: true },
        `${safeTilt.CODPAC || '-'} - ${safeTilt.NOMEPAC || '-'}`,
      ],
      margin: [0, 0, 0, 1],
    },
    {
      columns: [
        {
          text: [
            { text: 'Data de Nasc: ', bold: true },
            `${safeTilt.dataNasc || '-'}`,
            { text: '        Sexo: ', bold: true },
            String(safeTilt.SEXOPAC || '-'),
            { text: '        Idade: ', bold: true },
            `${safeTilt.idadePAC ?? '-'} anos`,
          ],
          width: '*',
        },
      ],
      margin: [0, 1, 0, 1],
    },
    {
      text: [
        { text: 'Convênio: ', bold: true },
        String(safeTilt.SIGLACONV || '-'),
        { text: '        Código: ', bold: true },
        String(safeTilt.CODTILT || '-'),
        { text: '        Data do Exame: ', bold: true },
        `${safeTilt.dataTilt || '-'}`,
      ],
      margin: [0, 1, 0, 1],
    },
    {
      columns: [
        {
          text: [
            { text: 'Médico que Realizou: ', bold: true },
            `Dr.(a): ${safeTilt.Realizou || '-'}`,
          ],
          width: '*',
        },
      ],
      margin: [0, 1, 0, 1],
    },
    {
      text: [
        { text: 'Médico que Solicitou: ', bold: true },
        `Dr.(a): ${safeTilt.Solicitou || '-'}`,
      ],
      margin: [0, 1, 0, 1],
    },
    {
      canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 0.5 }],
      margin: [0, 6, 0, 6],
    },
    // sectionTitle('Descrição'),
    {
      text: textoLaudo || 'Sem descrição preenchida.',
      margin: [10, 0, 0, 1],
    },
  ];

  /*   if (analiseLines.length > 0) {
    content.push(sectionTitle('Análise da Resposta Hemodinâmica'));
    analiseLines.forEach((line) => {
      content.push({ text: line, margin: [10, 0, 0, 1] });
    });
  } */

  content.push(
    {
      text: 'Conferido e assinado eletronicamente por:',
      italics: true,
      alignment: 'center',
      margin: [0, 20, 0, 3],
    },
    {
      text: `Dr(a).: ${safeTilt.Realizou || '-'}`,
      bold: true,
      alignment: 'center',
      margin: [0, 0, 0, 3],
    },
    {
      text:
        [
          safeTilt.CPFMED ? `CPF: ${safeTilt.CPFMED}` : null,
          safeTilt.CRMMED ? `CRM: ${safeTilt.CRMMED}` : null,
          safeTilt.RQE ? `RQE: ${safeTilt.RQE}` : null,
        ]
          .filter(Boolean)
          .join(' - ') || '-',
      bold: true,
      alignment: 'center',
      fontSize: 9,
      margin: [0, 0, 0, 3],
    },
    {
      text: `Assinatura Digital: ${hashAssinatura}`,
      bold: true,
      italics: true,
      alignment: 'center',
      fontSize: 9,
      margin: [0, 0, 0, 12],
    }
  );

  const docDefinition = {
    pageSize: 'A4',
    pageMargins: [40, 90, 40, 68],
    header: function () {
      return {
        stack: [
          {
            image: logoBase64,
            width: 460,
            alignment: 'center',
            margin: [0, 6, 0, 2],
          },
          {
            text: String(safeTilt.CODTILT || ''),
            bold: true,
            alignment: 'right',
            fontSize: 10,
            margin: [40, 0, 40, 0],
          },
        ],
      };
    },
    footer: function (currentPage, pageCount) {
      return [
        {
          canvas: [{ type: 'line', x1: 0, y1: 0, x2: 515, y2: 0, lineWidth: 0.5 }],
          margin: [40, 2, 40, 0],
        },
        {
          text: 'Rua Claudio Manuel da Costa, 56 - Fone (14) 3402-2700/Fax: (14) 3402-2705 - Jd Maria Isabel - CEP 17.515-460 - Marilia/SP',
          alignment: 'center',
          fontSize: 7,
          margin: [40, 2, 40, 0],
        },
        {
          text: 'prevencor@unimedmarilia.com.br',
          alignment: 'center',
          fontSize: 7,
          margin: [40, 0, 40, 0],
        },
        {
          text: `Pag: ${currentPage} de ${pageCount}`,
          alignment: 'center',
          fontSize: 8,
          bold: true,
          margin: [40, 1, 40, 0],
        },
      ];
    },
    content,
    defaultStyle: { fontSize: 12 },
  };

  pdfMake.createPdf(docDefinition).open();
  return docDefinition;
}

export default async function gerarPDFTilt(tilt) {
  return generatePDFTilt({ tilt });
}
